module.exports = __webpack_public_path__ + "img/military_base-hotspot-7.2.0e05e04a.png";